import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { treeInjectionKey as b } from "./interface.js";
import { render as u } from "../../_utils/vue/render.js";
import { defineComponent as C, inject as k, h as s } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as g } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const j = C({
  name: "TreeNodeContent",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    disabled: Boolean,
    checked: Boolean,
    selected: Boolean,
    onClick: Function,
    onDragstart: Function,
    tmNode: {
      type: Object,
      required: !0
    },
    nodeProps: Object
  },
  setup(e) {
    const {
      renderLabelRef: c,
      renderPrefixRef: n,
      renderSuffixRef: r,
      labelFieldRef: o
    } = k(b), f = g(null);
    function t(d) {
      const {
        onClick: l
      } = e;
      l && l(d);
    }
    function i(d) {
      t(d);
    }
    return {
      selfRef: f,
      renderLabel: c,
      renderPrefix: n,
      renderSuffix: r,
      labelField: o,
      handleClick: i
    };
  },
  render() {
    const {
      clsPrefix: e,
      labelField: c,
      nodeProps: n,
      checked: r = !1,
      selected: o = !1,
      renderLabel: f,
      renderPrefix: t,
      renderSuffix: i,
      handleClick: d,
      onDragstart: l,
      tmNode: {
        rawNode: a,
        rawNode: {
          prefix: p,
          suffix: x,
          [c]: m
        }
      }
    } = this;
    return s("span", Object.assign({}, n, {
      ref: "selfRef",
      class: [`${e}-tree-node-content`, n == null ? void 0 : n.class],
      onClick: d,
      draggable: l === void 0 ? void 0 : !0,
      onDragstart: l
    }), t || p ? s("div", {
      class: `${e}-tree-node-content__prefix`
    }, t ? t({
      option: a,
      selected: o,
      checked: r
    }) : u(p)) : null, s("div", {
      class: `${e}-tree-node-content__text`
    }, f ? f({
      option: a,
      selected: o,
      checked: r
    }) : u(m)), i || x ? s("div", {
      class: `${e}-tree-node-content__suffix`
    }, i ? i({
      option: a,
      selected: o,
      checked: r
    }) : u(x)) : null);
  }
});
export {
  j as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/src/TreeNodeContent.js
// module id = 1760
// module chunks = 67